module.exports = __webpack_public_path__ + "static/tokr-webHotels-ebda0f6ad5353404f68a20a1b84137eb.jpg";